import { action, computed, observable, runInAction } from "mobx";
import { createContext } from "react";
import { toast } from "react-toastify";
import agent from "../api/agent";
import { ITechnicianCertificateName } from "../models/techniciancertificatename";

class HRStore {
  @observable employeeCertificates: ITechnicianCertificateName[]  = [];
  @observable loadingInitial = false;
  @observable submitting = false;
  @observable unverifiedEmp: {name: string, email: string, unverifiedCert: number }[] =  [];

  @computed get verifiedCount() {
    let verified = 0;
    let unverified = 0;
    this.employeeCertificates.forEach((cert) => 
    {
       if (cert.verified === 'Y') verified++
       else unverified++;
    })
    return {verified: verified, unverified: unverified};
  }

  @computed get expireCertificate() {
    let expired = 0;
    let onemonth = 0;
    let threemonth = 0;
    let unexpire = 0;
    for (let i=0; i < this.employeeCertificates.length; i++)
    {
      if (this.employeeCertificates[i].expiryDate < new Date().toISOString())
      {
        expired++;
      }
      else if (this.employeeCertificates[i].expiryDate < new Date(new Date().setMonth(new Date().getMonth()+1)).toISOString())
      {
        onemonth++;
      }
      else if (this.employeeCertificates[i].expiryDate < new Date(new Date().setMonth(new Date().getMonth()+3)).toISOString())
      {
        threemonth++;
      }
      else
      {
        unexpire++;
      }
    };
    const expiry = {
      expired: expired,
      onemonth: onemonth,
      threemonth: threemonth,
      unexpire: unexpire,
    }
    return expiry;
  }

  @action loadCertificateCharts = async () => {
    this.loadingInitial = true;
    let count = 0;
    try {
      const employeeCertificates = await agent.HumanResource.certificateChart();
      runInAction("loading empolyees", () => {
         this.employeeCertificates.length = 0;
         this.unverifiedEmp.length = 0;
         for (let i=0; i < employeeCertificates.length; i++)
         {
          if(employeeCertificates[i].expiryDate) employeeCertificates[i].expiryDate = employeeCertificates[i].expiryDate.substr(0, 10);
          this.employeeCertificates.push(employeeCertificates[i]);
          if (employeeCertificates[i].verified !== 'Y') count++;
      if (i===employeeCertificates.length-1 || employeeCertificates[i].technicianEmail !== employeeCertificates[i+1].technicianEmail)
      {
        if (count !== 0) {
          let emp = {name: employeeCertificates[i].name, email: employeeCertificates[i].technicianEmail, unverifiedCert: count}; 
          this.unverifiedEmp.push(emp);
          count = 0;
        }
      }
         };
        this.loadingInitial = false;
      });
    } catch (error) {
      runInAction("load certificate chart Error", () => {
        this.loadingInitial = false;
      });
      toast.error("load certificate chart Error");
    }
  };

  @action changeList = async () => {
    let arr = this.unverifiedEmp;
    arr.push(this.unverifiedEmp[0])
    arr.splice(0,1)
    this.unverifiedEmp = arr;
  };

  

}

export default createContext(new HRStore());
